const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLoanIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m22,0c-3.2.2-6.3,1-9.1,2.4-1.9.9-3.5,2-5.1,3.5-.5.3-1.5,1.3-1.9,1.8-1.8,2.1-3.2,4.3-4.2,6.7-1,2.4-1.5,4.9-1.7,7.5v2.3c.2,3.3,1,6.3,2.4,9.2.9,1.9,2,3.5,3.5,5.1.4.4,1.4,1.5,1.8,1.8,2.2,2,4.6,3.4,7.4,4.5,2.2.8,4.5,1.3,6.9,1.4h2.3c2.1-.1,4.2-.5,6.1-1.1,2.5-.8,4.7-2,6.8-3.6.8-.6,1.5-1.2,2.3-2,1.1-1.1,2-2.1,2.8-3.4.6-.9,1-1.6,1.5-2.6,1.5-2.9,2.3-6,2.4-9.2v-3c-.1-1.9-.5-3.6-1.1-5.4-.8-2.5-2-4.7-3.6-6.8-.6-.8-1.2-1.5-2-2.3-1.1-1.1-2.1-2-3.4-2.8-.9-.6-1.6-1-2.6-1.5C30.6,1.1,27.6.3,24.3.1c-.4-.1-1.9-.1-2.3-.1m.5,3.4c-1.9.1-3.7.4-5.5,1-2.4.8-4.6,2-6.5,3.6-.8.7-1.7,1.6-2.4,2.4-1.9,2.3-3.3,5-4.1,8-.8,3-.8,6.4,0,9.5.7,2.9,2.1,5.7,4.1,8,.7.8,1.6,1.7,2.4,2.4,2.8,2.4,6.3,3.9,10,4.4,1.8.2,3.7.2,5.4,0,3.5-.5,6.8-1.9,9.5-4.1,1-.8,2-1.8,2.8-2.7,1.7-2,3-4.4,3.8-7,1-3.4,1.1-7,.2-10.5-.7-2.9-2.1-5.6-4-7.9-.7-.8-1.6-1.7-2.4-2.4-2.8-2.4-6.3-3.9-10-4.4-.7-.1-1.3-.1-2.1-.2q-.5-.1-1.2-.1",
    style: {
      fillRule: "evenodd",
      fill: "#81B214"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m17.7,33.6V12.6h3.8v17.8h9.2v3.2h-13Z",
    style: {
      fill: "#81B214"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoanIcon);
export default __webpack_public_path__ + "static/media/loan_icon.e54c2ca2b1ce5932702339d963b31250.svg";
export { ForwardRef as ReactComponent };